export default {"src":"/_next/static/media/facebook.5762371e.svg","height":30,"width":31,"blurWidth":0,"blurHeight":0};